export const site = {
  name: "爆料平台",
  shortName: "料台",
  tagline: "匿名爆料入口与内部消息投稿处",
  description:
    "线索汇聚中心。把手里的匿名材料放出来，不必暴露身份；内部消息、公众事件与维权线索在这里归档归类。",
  email: "contact@bailiao-hub.example.com",
  tipEmail: "tips@bailiao-hub.example.com",
  workTime: "线索受理：全年 24 小时；人工整理：每日 09:00 - 22:00",
  reviewCycle: "一般线索 48 小时内完成首轮归类，复杂线索 3 - 5 个工作日给出进度说明。",
  principles: [
    "只归档可被核实的信息，不替任何一方下结论。",
    "对投稿人身份做最小化留存，默认不向第三方提供。",
    "同一事件的多方说法并列呈现，不做单边叙述。",
    "已更新的线索在原文保留修改说明，方便追溯。",
  ],
};

export const stats = [
  { label: "累计收到线索", value: "12,860", suffix: "条" },
  { label: "已归类公开", value: "3,472", suffix: "条" },
  { label: "在核实中", value: "418", suffix: "条" },
  { label: "平均响应时间", value: "48", suffix: "小时" },
];